import { render } from "./LatestBlocks.vue?vue&type=template&id=cbe07c50"
import script from "./LatestBlocks.vue?vue&type=script&lang=js"
export * from "./LatestBlocks.vue?vue&type=script&lang=js"
script.render = render

export default script